(function () {
  'use strict';

  angular
      .module('tf.retailer')
      .factory('Retailer', Retailer);

  // @ngInject
  function Retailer(Api) {

    return {
      find : find
    };

    // TODO: Should handle api success in api.js (Remove this boilerplate code)
    function find() {
      return Api.get('/retailer', { cache : true }).then(_.property('data'));
    }

  }

})();
